import { computed } from 'vue'
import { useStore } from 'vuex'
import { useGetPromotions } from '@gto/api/vue-query'

export function usePromotions() {
  const store = useStore()
  const { data, isSuccess, isLoading } = useGetPromotions()

  const isLoadingPromotions = computed(() => isLoading.value)

  const userHasRbwizardPromo = computed(
    () => isSuccess.value && data.value?.rbwizard && store.getters.user_has_flag('RBWIZARD_PROMO'),
  )

  return {
    isLoadingPromotions,
    userHasRbwizardPromo,
  }
}
